module.exports = __webpack_public_path__ + "static/media/1018424.0ce5c949.png";